import React, { useEffect, useState } from "react";
import { BiLogoYoutube } from "react-icons/bi";
import { YoutubePosition } from "../dashboard/knowledge-bases-create/types";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";

type Props = {
  item?: any;
  type?: YoutubePosition;
};

const urlVideo = [
  {
    name: "VIDEOBOT_MESSAGE",
    url: "https://www.youtube.com/embed/qPl-2-sgsN0?rel=0&fs=1&showinfo=0"
  },
  {
    name: "BOT_MESSAGE",
    url: "https://www.youtube.com/embed/_Bug_3u-SHs?rel=0&fs=1&showinfo=0"
  },
  {
    name: "READ_USER_MESSAGE",
    url: "https://www.youtube.com/embed/21yIWjiUAmA?rel=0&fs=1&showinfo=0"
  },
  {
    name: "ADD_BUTTON",
    url: "https://www.youtube.com/embed/yWmzlmEA1kQ?rel=0&fs=1&showinfo=0"
  },
  {
    name: "ADD_LINK",
    url: "https://www.youtube.com/embed/2UznkHXiJfk?rel=0&fs=1&showinfo=0"
  },
  {
    name: "ASSIGN_VARIABLE",
    url: "https://www.youtube.com/embed/UVKGnpU7gq0?rel=0&fs=1&showinfo=0"
  },
  {
    name: "HTTP_REQUEST",
    url: "https://www.youtube.com/embed/NCkG2pg1Bp4?rel=0&fs=1&showinfo=0"
  },
  {
    name: "NOTIFY_ME_BY_EMAIL",
    url: "https://www.youtube.com/embed/FC0lmCq1Y5c?rel=0&fs=1&showinfo=0"
  },
  {
    name: "RECEIVE_ATTACHMENT",
    url: "https://www.youtube.com/embed/kcIeS71UdoM?rel=0&fs=1&showinfo=0"
  },
  {
    name: "CONDITIONS",
    url: "https://www.youtube.com/embed/UdCs1MXngpc?rel=0&fs=1&showinfo=0"
  },
  {
    name: "OVERRIDE_VARIABLE",
    url: "https://www.youtube.com/embed/uhnK5MayVkk?rel=0&fs=1&showinfo=0"
  },
  {
    name: "CREATE_VARIABLE",
    url: "https://www.youtube.com/embed/uhnK5MayVkk?rel=0&fs=1&showinfo=0"
  },
  {
    name: "SEND_MEDIA",
    url: "https://www.youtube.com/embed/A9gmpr1HsJE?rel=0&fs=1&showinfo=0"
  },
  {
    name: "SEND_ATTACHMENT",
    url: "https://www.youtube.com/embed/Z1FZvbWj2R0?rel=0&fs=1&showinfo=0"
  },
  {
    name: "LEAD_FORM",
    url: "https://www.youtube.com/embed/d96qQ53t4Bw?rel=0&fs=1&showinfo=0"
  },
  {
    name: "END_OF_CONVERSATION",
    url: "https://www.youtube.com/embed/aGXEdCacJaY?rel=0&fs=1&showinfo=0"
  },
  {
    name: "DELAY",
    url: "https://www.youtube.com/embed/UKG1GdeJTX0?rel=0&fs=1&showinfo=0"
  },
  {
    name: "GO_TO",
    url: "https://www.youtube.com/embed/mYWxJWAPcVE?rel=0&fs=1&showinfo=0"
  },
  {
    name: "MAKE_WEBHOOK",
    url: "https://www.youtube.com/embed/xrq-U0nGZjE?rel=0&fs=1&showinfo=0"
  },
  // {
  //   name: "PASS_TO_AI",
  //   url: "https://www.youtube.com/embed/xrq-U0nGZjE?rel=0&fs=1&showinfo=0"
  // },
  // {
  //   name: "SWITCH_TO_CHATBOT",
  //   url: "https://www.youtube.com/embed/xrq-U0nGZjE?rel=0&fs=1&showinfo=0"
  // },
  // {
  //   name: "SUPER_USER_MANAGER_SERVICES",
  //   url: ""
  // },
  // { name: "CHECK_IF_USER_EXISTS", url: "" },
  // { name: "USER_CREDENTIAL", url: "" },
  // { name: "GET_USER_INFO", url: "" },
  // { name: "REGISTER_USER", url: "" }
];

function ScenarioYoutubeVideo({ item, type = YoutubePosition.Other }: Props) {
  const [isVideo, setIsVideo] = useState(false);
  const [show, setShow] = useState(false);
  const [url, setUrl] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    const find = urlVideo.find((dr: any) => dr.name == item.name);
    if (item && find) {
      setIsVideo(true);
      setUrl(find.url);
    }
  }, [item]);

  return (
    <React.Fragment>
      {isVideo &&
        (type == YoutubePosition.ScenarioHeader ? (
          <button
            role="button"
            type="button"
            onClick={() => {
              setShow(true);
            }}
            className="tw-bg-white tw-rounded-full tw-shadow-sm tw-border tw-border-gray-300 tw-justify-center tw-items-center tw-gap-2 tw-border-solid tw-flex tw-p-2.5 sm:tw-pl-3 sm:tw-pr-4 sm:tw-py-2.5"
          >
            <BiLogoYoutube size={24} className="tw-text-red-500" />
            <div className="tw-hidden sm:tw-block tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
              {t("BotTypedVideoTutorial/tutorial")}
            </div>
          </button>
        ) : (
          <button
            type="button"
            onClick={() => {
              setShow(true);
            }}
            className="tw-border-none tw-bg-transparent  tw-w-full tw-h-full tw-z-999"
          >
            <BiLogoYoutube size={50} className="tw-text-red-500" />
          </button>
        ))}

      <Modal
        size="lg"
        show={show}
        onHide={() => setShow(false)}
        centered
        style={{ maxWidth: "100%" }}
      >
        <Modal.Header closeButton className="tw-border-0 tw-items-start">
          <span className="tw-text-zinc-900 tw-text-xl tw-font-bold tw-font-['Sofia Sans'] tw-items-start tw-justify-between">
            {t("BotTypedVideoTutorial/tutorial")}
          </span>
        </Modal.Header>
        <Modal.Body>
          <iframe
            src={url}
            width="100%"
            className="md:tw-h-[28rem] sm:tw-h-full"
            style={{ border: "none" }}
            title="Tutorial Iframe"
          ></iframe>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export default ScenarioYoutubeVideo;
